import SupportTopicInputAttachedImagesList from "./inputAttachedImagesList";
import {ConstructionComponentInfo} from "@interfaces/constructor/constructor";

const SupportTopicInputAttachedImagesListInfo: ConstructionComponentInfo = {
    component: SupportTopicInputAttachedImagesList,
    addedChildProps: [
        'attached_image_id',
        'attached_image_url',
        'attached_image_name',
        'attached_image_uploading',
        'attached_image_upload_progress',
        'remove_attached_image'
    ]
}

export {
    SupportTopicInputAttachedImagesListInfo
}